import { RouteConfig } from 'vue-router';
import SwForgotUsername from './components/sw-forgot-username.vue';

export const forgotUsernameRoute: RouteConfig = {
  path: 'forgotusername',
  component: SwForgotUsername,
};
